import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "./ShopByCategory.css";

const TrendingItems = () => {
  const { addToCart } = useCart();
  const { addToWishlist, removeFromWishlist, wishlist } = useWishlist();
  const navigate = useNavigate();
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendingProducts = async () => {
      try {
        const response = await axios.get("https://madhusewingmachines.com/api/products/trending");
        console.log("API Response:", response.data);

        // Handle different possible response structures
        const products = response.data.products ||
          response.data.data ||
          (Array.isArray(response.data) ? response.data : []);

        setTrendingProducts(products);
      } catch (error) {
        console.error("Error fetching trending products:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingProducts();
  }, []);

  const handleAddToCart = (product) => {
    addToCart(product);
    toast.success("🛒 Added to Cart!", { position: "top-center", autoClose: 2000 });
  };

  const handleWishlistToggle = (product) => {
    const isInWishlist = wishlist.some((item) => item._id === product._id);
    if (isInWishlist) {
      removeFromWishlist(product._id);
      toast.error("💔 Removed from Wishlist!", { position: "top-center", autoClose: 2000 });
    } else {
      addToWishlist(product);
      toast.success("❤️ Added to Wishlist!", { position: "top-center", autoClose: 2000 });
    }
  };

  const handleImageClick = (id) => {
    navigate(`/product/${id}`);
  };

  if (loading) {
    return (
      <Container fluid className="py-5 d-flex justify-content-center" style={{ backgroundColor: "#EFFBFF" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="py-5 text-center" style={{ backgroundColor: "#EFFBFF" }}>
        <h2>Error loading trending products</h2>
        <p>{error}</p>
      </Container>
    );
  }

  if (!trendingProducts || trendingProducts.length === 0) {
    return (
      <Container fluid className="py-5 text-center" style={{ backgroundColor: "#EFFBFF" }}>
        <h2>No trending products found</h2>
      </Container>
    );
  }

  return (
    <Container fluid className="py-5" style={{ backgroundColor: "#EFFBFF" }}>
      <h2 className="category-heading">✨ Trending Items ✨</h2>

      <div className="product-scroll">
        {trendingProducts.map((product) => {
          const isInWishlist = wishlist.some((item) => item._id === product._id);
          const mainImage = product.images?.[0] || '';

          return (
            <div key={product._id} className="product-item">
              <Card className="border-0 shadow-sm p-3 bg-white text-center position-relative">
                {isInWishlist ? (
                  <FaHeart
                    size={24}
                    className="position-absolute top-0 end-0 m-3"
                    style={{ cursor: "pointer", color: "red" }}
                    onClick={() => handleWishlistToggle(product)}
                  />
                ) : (
                  <FaRegHeart
                    size={24}
                    className="position-absolute top-0 end-0 m-3"
                    style={{ cursor: "pointer", color: "#ccc" }}
                    onClick={() => handleWishlistToggle(product)}
                  />
                )}

                <Card.Img
                  variant="top"
                  src={mainImage.url ? `https://madhusewingmachines.com/uploads/${mainImage.url}` : mainImage}
                  className="img-fluid"
                  style={{
                    height: "clamp(140px, 20vh, 170px)",
                    objectFit: "contain",
                    cursor: "pointer",
                  }}
                  onClick={() => handleImageClick(product._id)}
                />

                <Card.Body>
                  <Card.Title className="fw-bold" style={{ fontSize: "clamp(1rem, 2vw, 1.2rem)" }}>
                    {product.name}
                  </Card.Title>
                  <Card.Text className="text-muted">{product.type}</Card.Text>

                  <div className="d-flex justify-content-center align-items-center">
                    <span className="fw-bold fs-5">₹{product.price}</span>
                    {product.originalPrice && (
                      <>
                        <span className="text-muted mx-2" style={{ textDecoration: "line-through" }}>
                          ₹{product.originalPrice}
                        </span>
                        {product.discount && (
                          <span className="text-success fw-bold">({product.discount})</span>
                        )}
                      </>
                    )}
                  </div>
                </Card.Body>

                <Button
                  className="w-100 fw-bold rounded-pill"
                  style={{ backgroundColor: "#64C3F9", border: "none", padding: "8px 0" }}
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </Button>
              </Card>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default TrendingItems;